import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'login';
import { debugAuth } from 'src/app/debug/auth-debug';

@Component({
  selector: 'app-loading',
  standalone: true,
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly loginService = inject(LoginService);

  public async ngOnInit(): Promise<void> {
    debugAuth('loading component init', {
      currentUrl: this.router.url,
      loginHost: undefined
    });

    const userEmail = await this.loginService.getUserEmail();
    debugAuth('loading component resolved user', {
      userEmail: Boolean(userEmail),
      userEmailValue: userEmail
    });

    await this.router.navigateByUrl(userEmail ? '/hub' : '/login', { replaceUrl: true });
  }
}
